import { createApp } from 'vue'
import 'virtual:svg-icons-register'

import { setupStore } from '@/store'

import App from '@/views/live/desktop/index.vue'

import '@/core'

import '@/plugins'

import 'uno.css'

import '@/views/live/desktop/global.less'

const app = createApp(App)

function render(props: any, App: any) {
  // 判断是不是qiankun的
  const { container } = props

  // 配置store
  setupStore(App)

  App.mount(
    typeof container === 'string' ? container : (container.querySelector('#app') as Element)
  )
}

const sections = [
  ['#app', app],
];

sections.forEach(([container, content]) => render({ container }, content));
